import { IBasketOrderItemCheckoutPrice } from "../order/types";


export default class BasketOrderItemCheckoutPrice implements IBasketOrderItemCheckoutPrice  {

  amount: number;

  constructor(
    amount: number
  ) {
    this.amount = amount;
  }

}
